import { z } from 'zod'

// 탭② 카테고리 단가 — 검색 필터 (국가·서비스항목 필수 / 주문유형·단위·상태·물류카테고리(다중)·기간)
// 단위(unitType): PCS/BOX 차원 도입(LOGISPRD-9632)에 따라 검색 필터 제공 (LOGISPRD-9510)
export const categoryPriceListSchema = z.object({
  country: z.string().min(1, '국가를 선택해 주세요.'),
  serviceType: z.string().min(1, '서비스 항목을 선택해 주세요.'),
  orderType: z.string().nullable(),
  unitType: z.string().nullable(),
  status: z.string().nullable(),
  logisticsCategoryCodes: z.array(z.string()),
  bizestCategories: z.array(z.string()),
  startDate: z.string().optional(),
  endDate: z.string().optional(),
})

export type CategoryPriceListSchemaType = z.infer<typeof categoryPriceListSchema>

export const getInitForm = (parsedQs: Partial<CategoryPriceListSchemaType> = {}): CategoryPriceListSchemaType => {
  return {
    country: parsedQs.country ?? '',
    serviceType: parsedQs.serviceType ?? '',
    orderType: parsedQs.orderType ?? null,
    unitType: parsedQs.unitType ?? null,
    status: parsedQs.status ?? null,
    logisticsCategoryCodes: parsedQs.logisticsCategoryCodes ?? [],
    bizestCategories: parsedQs.bizestCategories ?? [],
    startDate: parsedQs.startDate,
    endDate: parsedQs.endDate,
  }
}
